let paiAges = [
    {
        min: 0,
        max: 2,
        organism: [0,1,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    },
    {
        min: 2,
        max: 4,
        organism: [0,0,1,1,1,0,0,0,0,0,0,1,0,0,0,0,1,1,0,0,0,0,0,0,1,0],
    },
    {
        min: 4,
        max: 6,
        organism: [0,0,1,1,1,0,0,0,0,0,0,1,0,0,0,0,1,1,0,0,0,0,0,0,1,0],
    },
    {
        min: 6,
        max: 7,
        organism: [0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,1,0,1,0,0,0,0,0,1,0],
    },
    {
        min: 7,
        max: 9,
        organism: [0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0],
    },
    /* van 5*/
    {
        min: 9,
        max: 12,
        organism: [0,0,0,0,1,0,0,0,0,0,0,1,0,0,0,0,1,0,0,0,0,0,0,0,0,0],
    },
    {
        min: 12,
        max: 15,
        organism: [0,1,0,0,1,0,0,0,1,0,0,1,1,1,0,0,1,0,1,0,1,0,0,0,1,0],
    },
    {
        min: 15,
        max: 18,
        organism: [0,1,0,0,1,0,0,0,1,0,0,1,1,1,0,0,1,0,1,0,1,0,0,0,1,0],
    },
    {
        min: 18,
        max: 19,
        organism: [0,1,0,0,1,0,0,0,1,0,0,1,1,1,0,0,1,0,1,0,1,0,0,0,1,0],
    },
    {
        min: 19,
        max: 24,
        organism: [0,1,0,0,1,0,0,0,1,0,0,1,1,1,0,0,1,0,1,0,1,0,0,0,1,0],
    },
    {
        min: 24,
        max: 48,
        organism: [0,0,0,0,1,0,0,1,1,0,0,0,0,1,0,0,1,0,0,0,1,0,0,0,1,0],
    },
    {
        min: 48,
        max: 60,
        organism: [0,1,0,1,1,0,0,1,1,0,0,1,1,1,0,0,1,0,0,0,1,0,0,0,1,0],
    },
    {
        min: 60,
        max: 72,
        organism: [0,1,0,1,1,0,0,1,1,0,0,1,1,1,0,0,1,0,0,0,1,0,0,0,1,0],
    },
    {
        min: 72,
        max: 108,
        organism: [0,0,0,0,1,0,0,1,1,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0],
    },
    /* van 10*/
    {
        min: 108,
        max: 120,
        organism: [0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0],
    },
    {
        min: 120,
        max: 144,
        organism: [0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0],
    },
    {
        min: 144,
        max: 216,
        organism: [0,0,0,0,1,1,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    },
    {
        min: 216,
        max: 228,
        organism: [0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    },
    {
        min: 228,
        max: 324,
        organism: [0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    },
    /* van 15*/
    {
        min: 324,
        max: 600,
        organism: [0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    },

    {
        min: 600,
        max: 672,
        organism: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0],
    },
    {
        min: 672,
        max: 720,
        organism: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0],
    },
    {
        min: 720,
        max: 780,
        organism: [0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1,0,0,0,0,0,0],
    },
    {
        min: 780,
        max: 10000,
        organism: [0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,1,1,0,0,0,0,0,0]
    },
];

export default paiAges;